import React from "react";
import { useTranslation } from 'react-i18next';
import {
  Wrapper,
  Header,
  SubTitle,
  Text,
  Card,
  Logo,
} from "../styles";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import MicrosoftLoginForm from "../../../containers/user-management/MicrosoftLoginForm/MicrosoftLoginForm";
import LanguageDropdown from "../../../components/LanguageDropdown";

const MicrosoftLoginPage = () => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <LanguageDropdown />
      <Wrapper>
        <Header>
          <Logo src="/logo.png" alt="Offolio Logo" />
          <SubTitle>{t('microsoftLoginPage.title')}</SubTitle>
          <Text>{t('microsoftLoginPage.subtitle')}</Text>
        </Header>

        <Card>
          <MicrosoftLoginForm />
        </Card>
      </Wrapper>
    </PageWrapper>
  );
};

export default MicrosoftLoginPage;
